/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetDriftWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("BudgetDriftWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return BudgetDriftWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BudgetDriftWidgetConfiguration>): BudgetDriftWidgetConfiguration {
        let obj = Object.assign(new BudgetDriftWidgetConfiguration(), model);
        BudgetDriftWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetDriftWidgetConfiguration>): BudgetDriftWidgetConfiguration {
        if (!model) return null;
        return BudgetDriftWidgetConfiguration.newInstance(<BudgetDriftWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetDriftWidgetConfiguration) {
        if (!obj) return;

        models.BudgetDriftWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetDriftWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BudgetDriftWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of budget
     */
    configurationType: models.BudgetType;

}
